import axiosFlow from '@/services/axios/axiosFlow'

export default class ClienteService {
  static async getSolicitanteByQuery(input) {
    return axiosFlow.get(`clientes/query?Input=${input}`).then(res => res.data.data)
  }

  static async getSolicitantes() {
    return axiosFlow.get('clientes').then(res => res.data.data)
  }

  static async getAtendimentosSolicitante(solicitanteId) {
    return axiosFlow.get(`tickets/solicitante?IdSolicitante=${solicitanteId}`).then(res => res.data.data)
  }

  static async getSolicitante(solicitanteId) {
    return axiosFlow.get(`clientes/${solicitanteId}`).then(res => res.data.data)
  }

  static async createSolicitante(body) {
    return axiosFlow.post('clientes', body)
  }

  static async updateSolicitante(clienteId, body) {
    return axiosFlow.put(`clientes/${clienteId}`, body)
  }
}
